import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import type { BoUser } from '../lib/permissions';

interface SessionState {
  user: BoUser | null;
  token: string | null;
  refreshToken: string | null;
  tokenExpiresAt: string | null;
  login: (
    u: BoUser,
    token?: string | null,
    refreshToken?: string | null,
    tokenExpiresAt?: string | null,
  ) => void;
  setAuthTokens: (
    token: string,
    refreshToken: string,
    tokenExpiresAt: string,
  ) => void;
  logout: () => void;
}
export const useSession = create<SessionState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      refreshToken: null,
      tokenExpiresAt: null,
      login: (user, token = null, refreshToken = null, tokenExpiresAt = null) =>
        set({ user, token, refreshToken, tokenExpiresAt }),
      setAuthTokens: (token, refreshToken, tokenExpiresAt) =>
        set({ token, refreshToken, tokenExpiresAt }),
      logout: () =>
        set({
          user: null,
          token: null,
          refreshToken: null,
          tokenExpiresAt: null,
        }),
    }),
    {
      name: 'pos-dashboard-session',
      // Keep the dashboard session across reloads, but isolate it to this tab
      // and clear it automatically when the browser tab is closed.
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        user: state.user,
        token: state.token,
        refreshToken: state.refreshToken,
        tokenExpiresAt: state.tokenExpiresAt,
      }),
    },
  ),
);
